import * as $ from 'jquery';
import 'bootstrap';
import 'slick';

export class enrichCardBenefitsPrivileges{
	private enCard:any = $('#enrich_benefits_component'); // parent component
	private enCardMob:any = $('#enrich_benefits_component_mobile'); // parent component for mobile

	/**
	 * Accordion event handler
	 * Toggle accordion angle icon direction when expanded
	 */
	accordionEventHandler(): any {
		let _self = this;
		let enCardAccordion = _self.enCard.find('.card-info-accordion'); // all accordion objects

		for (var i=0, len=enCardAccordion.length; i<len; i++) {

			// when opening accordion, find target's heading icon and change class from
			// "fa-angle-up" to "fa-angle-down"
			$(enCardAccordion[i]).on('show.bs.collapse', function(e:any){
				toggleCollapse(e);
			});

			// when closing accordion, find target's heading icon and change class from
			// "fa-angle-down" to "fa-angle-up"
			$(enCardAccordion[i]).on('hide.bs.collapse', function(e:any){
				toggleCollapse(e);
			});
		}

		// for mobile accordion
		let enCardAccordionMob = _self.enCardMob.find('.card-info-accordion'); // all accordion objects

		for (var i=0, len=enCardAccordionMob.length; i<len; i++) {

			// when opening accordion, find target's heading icon and change class from
			// "fa-angle-up" to "fa-angle-down"
			$(enCardAccordionMob[i]).on('show.bs.collapse', function(e:any){
				toggleCollapse(e);
			});

			// when closing accordion, find target's heading icon and change class from
			// "fa-angle-down" to "fa-angle-up"
			$(enCardAccordionMob[i]).on('hide.bs.collapse', function(e:any){
				toggleCollapse(e);
			});
		}

		function toggleCollapse(el:any) {
			let icon = el.target.previousElementSibling.querySelector('i.fa');
			icon.classList.toggle('fa-angle-up');
			icon.classList.toggle('fa-angle-down');
			return;
		}
	}

	/**
	 * Tab event handler
	 * Toggle tab angle icon direction when expanded
	 */
	tabEventHandler(): any {
		let _self = this;
		let enCardTabs = _self.enCard.find('.nav.nav-tabs');

		for (var i=0, len=enCardTabs.length; i<len; i++) {

			// when opening tab, find target's heading icon and change class from
			// "fa-angle-right" to "fa-angle-up"
			$(enCardTabs[i]).on('show.bs.tab', function(e:any){
				let icon = e.target.querySelector('i.fa');
				icon.classList.toggle('fa-angle-right');
				icon.classList.toggle('fa-angle-up');
			});

			// when closing tab, find target's heading icon and change class from
			// "fa-angle-up" to "fa-angle-right"
			$(enCardTabs[i]).on('hide.bs.tab', function(e:any){
				let icon = e.target.querySelector('i.fa');
				icon.classList.toggle('fa-angle-right');
				icon.classList.toggle('fa-angle-up');
			});
		}
	}

	mobAccordionEventHandler(): any {
		let _self = this;
		let enCardAccordionMob = _self.enCardMob; // all accordion objects

		// when opening tab, find target's heading icon and change class from
		// "fa-angle-right" to "fa-angle-up"
		enCardAccordionMob.on('show.bs.collapse', function(e:any){
			toggleCollapse(e);
		});

		// when closing accordion, find target's heading icon and change class from
		// "fa-angle-up" to "fa-angle-right"
		enCardAccordionMob.on('hide.bs.collapse', function(e:any){
			toggleCollapse(e);
		});

		function toggleCollapse(el:any) {
			let icon = el.target.previousElementSibling.querySelector('i.fa');
			icon.classList.toggle('fa-angle-right');
			icon.classList.toggle('fa-angle-up');
			return;
		}
	}

	/**
	 * Show more accordion items in mobile
	 * on clicking 'show more' button, find all hidden accordions in currently active
	 * tab content and display them (remove hidden-xs class)
	 * no need to constrain by window width since button
	 * is only displayed in mobile (<768px)
	 * after hidden accordions are displayed, hide the 'show more' button
	 */
	displayMoreMob(): any {
		let _self = this;
		let moreBtn = _self.enCardMob.find('.enrich_card_show_more');

		// attach event handler for all 'show more' buttons
		for (var i=0, len=moreBtn.length; i<len; i++) {
			$(moreBtn[i]).on('click', function(e:any){
				e.stopPropagation();
				e.preventDefault();

				// find all hidden accordions
				let accordionTarget = _self.enCardMob.find('#'+this.dataset.target);
				let hiddenAccordions = accordionTarget.find('.ipad-mob_view');

				for (var j=0, len2=hiddenAccordions.length; j<len2; j++) {
					hiddenAccordions[j].classList.remove('ipad-mob_view');
				}

				// hide 'show more' button
				this.classList.add('hidden');
			});
		}
	}

	/**
	 * initialize carousel on enrich card tabs if the number of available tabs is more than 4
	 * carousel initialized only at >= 1200px
	 * use slick.js for carousel functionality
	 * @return {any} [description]
	 */
	initNavTabsCarousel(): any {
		let breakpoint:number = 1200;
		let _self            = this;
		let cardTabs         = _self.enCard.find('.nav-tabs li[role="presentation"]');
		let cardTabContainer = _self.enCard.find('.nav-tabs');
		let slickObj:any;
		let slickParams:any  = {
			dots:     false,
			arrows:   true,
			infinite: false,
			speed:    400,
			autoplay: false,
			slidesToShow:   4,
			slidesToScroll: 1
		};

		// initialize carousel if more than 4 tabs
		if (cardTabs.length > 4) {
			// assign slick obj to variable when initialized for reference elsewhere
			cardTabContainer.on('init', function(e:any, slick:any){
				slickObj = slick;
			});

			// init event handler for switching slides
			slickBSTabHackEventHandler(cardTabs);

			// init resize event handler for toggling carousel instance
			slickWinResizeNavTabHandler();

			// initialize carousel if window > breakpoint
			if (window.innerWidth > breakpoint) {
				cardTabContainer.slick(slickParams);
			}

		} else {
			return false;
		}

		/**
		 * init event handler for switching slides
		 * ----
		 * this handler toggles the presence of the class 'active' on the <li> element
		 * and the value of 'aria-expanded="active"' on the nested <a> element, which
		 * handles the bootstrap tab implementation.
		 *
		 * as slick disables event propagation, clicking on the slide (<li>) only
		 * triggers slick functions, while completely disregarding bootstrap tabs
		 * thus we have to manually handle class/attr on tab items to play well with slick.
		 */
		function slickBSTabHackEventHandler(cardTabs:any) {
			cardTabs.on('click', function(e:any) {
				if (slickObj) {
					// remove active class and aria-expanded="active" on all other tab items
					// that were not clicked
					for (var i=0, len=cardTabs.length; i<len; i++) {
						cardTabs[i].classList.remove('active');
						cardTabs[i].querySelector('a[role="tab"]').removeAttribute('aria-expanded');
					}
				} else {
					return;
				}
			});

			return;
		}

		/**
		 * init resize event handler for toggling carousel instance
		 * ---
		 * basically window.resize with a settimeout delay before triggering function
		 * to prevent overflow
		 */
		function slickWinResizeNavTabHandler() {
			var endTimeout:any;
			window.onresize = function(){
				clearTimeout(endTimeout);
				endTimeout = setTimeout(doAfterResize, 100);
			};
		}

		/**
		 * do stuff here when resize event has ended
		 * stuff to do:
		 * - if window > breakpoint
		 * ---- initialize slick if not present
		 * - else
		 * ---- destroy slick instance if present
		 * ---- clear slick object reference
		 */
		function doAfterResize(){
			if (window.innerWidth > breakpoint) {
				if (!slickObj) {
					cardTabContainer.slick(slickParams);
				}
			} else {
				if (slickObj && slickObj.$list.length) {
					cardTabContainer.slick('unslick');
					slickObj = undefined;
				}
			}
		return;
		}
	}
}

let scope:Element = document.querySelector('#enrich_benefits_component');
if (scope){
	try {
	let enrichcardBenPriv = new enrichCardBenefitsPrivileges();
			enrichcardBenPriv.accordionEventHandler();
			enrichcardBenPriv.mobAccordionEventHandler();
			enrichcardBenPriv.tabEventHandler();
			enrichcardBenPriv.displayMoreMob();
			enrichcardBenPriv.initNavTabsCarousel();
	} catch(e) {console.error(e);}
}
